import { render, staticRenderFns } from "./NewDImageUploadEditor.vue?vue&type=template&id=3256b6a0&"
import script from "./NewDImageUploadEditor.vue?vue&type=script&lang=js&"
export * from "./NewDImageUploadEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewDImageUploadEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports